var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71998 22.4002V26.8802H49.28V22.4002H6.71998ZM5.59998 20.1602H50.4C51.0185 20.1602 51.52 20.6616 51.52 21.2802V28.0002C51.52 28.6187 51.0185 29.1202 50.4 29.1202H5.59998C4.98142 29.1202 4.47998 28.6187 4.47998 28.0002V21.2802C4.47998 20.6616 4.98142 20.1602 5.59998 20.1602ZM34.72 40.3202C34.1014 40.3202 33.6 39.8187 33.6 39.2002C33.6 38.5816 34.1014 38.0802 34.72 38.0802H43.68C44.2985 38.0802 44.8 38.5816 44.8 39.2002C44.8 39.8187 44.2985 40.3202 43.68 40.3202H34.72Z",
    fill: "#5CA9D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.32 13.4402C9.22719 13.4402 6.71998 15.9474 6.71998 19.0402V39.2002C6.71998 42.293 9.22719 44.8002 12.32 44.8002H43.68C46.7728 44.8002 49.28 42.293 49.28 39.2002V19.0402C49.28 15.9474 46.7728 13.4402 43.68 13.4402H12.32ZM12.32 11.2002H43.68C48.0099 11.2002 51.52 14.7103 51.52 19.0402V39.2002C51.52 43.5301 48.0099 47.0402 43.68 47.0402H12.32C7.99007 47.0402 4.47998 43.5301 4.47998 39.2002V19.0402C4.47998 14.7103 7.99007 11.2002 12.32 11.2002Z",
    fill: "#005383"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCard);
export default __webpack_public_path__ + "static/media/payment-card.2d33ce280a83e16d02bd493bc28ae6ab.svg";
export { ForwardRef as ReactComponent };